module.exports = __webpack_public_path__ + "static/img/lx.3b1f616f.jpg";